function fromBinary (binary) {
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < bytes.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    return String.fromCharCode(...new Uint16Array(bytes.buffer));
}

function toBinary(string) {
    const codeUnits = new Uint16Array(string.length);
    for (let i = 0; i < codeUnits.length; i++) {
      codeUnits[i] = string.charCodeAt(i);
    }
    return String.fromCharCode(...new Uint8Array(codeUnits.buffer));
}

function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

const COOKIE = 'profile-switch'

export function _getCookie() {
    const cookie = getCookie(COOKIE)

    if (cookie) {
        return JSON.parse(fromBinary(atob(cookie)))
    } else {
        return null
    }
}

export default {
    methods: {
        _setCookie: function(content) {
            document.cookie = COOKIE + '=' + btoa(toBinary(JSON.stringify(content))) + '; expires=Fri, 31 Dec 9999 23:59:59 GMT'
        },
        _getCookie
    }
}
